import {
  assert,
  reportError,
  parseMediaSrc,
  createMediaSrc,
  composeSDKFactories,
  basePropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import type { Image3Props } from './Image3.types';
import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';

export const createSdk: CorvidSDKFactory<Image3Props> = api => {
  const { props, setProps } = api;
  return {
    get src() {
      return (
        createMediaSrc({
          type: 'image',
          mediaId: props?.image?.uri,
          title: props?.image?.name,
          width: props?.image?.width,
          height: props?.image?.height,
        }).item ?? ''
      );
    },
    set src(value) {
      const src = assert.isNil(value) ? '' : value;
      const {
        height,
        width,
        title: name,
        error,
        mediaId: uri,
      } = parseMediaSrc(src.toString(), 'image');
      if (error) {
        reportError(
          `The "src" property cannot be set to "src". It must be a valid URL starting with "http://", "https://", or "wix:image://".`,
        );
        return;
      }
      const { image } = props;
      const currentImageData = image;

      const updatedImageData = {
        ...currentImageData,
        width: width || currentImageData?.width,
        height: height || currentImageData?.height,
        uri: uri || currentImageData?.uri,
        name: name || currentImageData?.name,
        crop: null,
      };
      setProps({
        image: updatedImageData,
      });
    },

    get alt() {
      return props.image?.alt;
    },

    set alt(value) {
      if (assert.isNil(value)) {
        const image = props.image || {};
        delete image.alt;
        setProps({ image });
      } else {
        setProps({
          image: {
            ...props.image,
            alt: value,
          },
        });
      }
    },

    get displayMode() {
      return props.displayMode;
    },

    set displayMode(displayMode: Image3Props['displayMode']) {
      setProps({
        displayMode,
      });
    },

    get name() {
      return props?.image?.name;
    },

    set name(value) {
      setProps({
        image: {
          ...props.image,
          name: value,
        },
      });
    },

    get type() {
      return '$w.Image';
    },
    toJSON() {
      return {
        // ...toJSONBase(metaData),
        type: '$w.Image',
        alt: props?.image?.alt,
        src: props?.image?.uri,
        name: props?.image?.name,
      };
    },
  };
};

export default composeSDKFactories([createSdk, basePropsSDKFactory]);
